// Executive Overview data extracted from Executive_Overview_Dashboard.html

export const CIRCLE_DATA = {
  HP: { gross: 72.79, cm_pen: 3.28, ftkm_rwd: 0, patrol: 0.22, pm_ded: 4.12, manpower: 8.60, material: 0.50, pq: 0.10, flap: 0.16, net: 55.82, km: 6873 },
  KS: { gross: 70.83, cm_pen: 1.94, ftkm_rwd: 1.78, patrol: 0.17, pm_ded: 3.49, manpower: 15.03, material: 0, pq: 0.20, flap: 0.01, net: 51.77, km: 4437 },
  JA: { gross: 55.56, cm_pen: 2.08, ftkm_rwd: 0, patrol: 0.09, pm_ded: 5.71, manpower: 10.58, material: 0.46, pq: 1.00, flap: 0.07, net: 35.57, km: 3553 },
  UW: { gross: 263.14, cm_pen: 9.84, ftkm_rwd: 5.41, patrol: 0.25, pm_ded: 5.93, manpower: 56.25, material: 2.05, pq: 0, flap: 0.42, net: 193.81, km: 26040 },
};

export const TOTAL = {
  gross: 462.32, cm_pen: 17.14, ftkm_rwd: 7.19, patrol: 0.73, pm_ded: 19.25,
  manpower: 90.46, material: 3.01, pq: 1.30, flap: 0.66, net: 336.97
};

// [circle, mp, km, manpower, pm_ded, cm_net, avg_cm_score]
export const MP_DATA = [
  ['KS', 'Srinagar', 4437.5, 15.03, 3.49, 1.94, 52],
  ['JA', 'Jammu', 3552.6, 10.58, 5.71, 2.08, 52],
  ['UW', 'Aligarh', 3751.2, 8.44, 1.87, 1.25, 60],
  ['UW', 'Agra', 2221.0, 8.03, 0.86, 1.00, 32],
  ['UW', 'Meerut', 2178.6, 7.18, 0.14, 0.99, 55],
  ['UW', 'Hapur', 2646.2, 6.90, 1.21, 1.20, 38],
  ['UW', 'Muzaffarnagar', 2997.6, 5.81, 0.79, 1.36, 58],
  ['UW', 'Etawah', 3470.9, 5.33, 0.77, 1.51, 60],
  ['HP', 'Shimla', 2541.1, 3.65, 1.38, 1.20, 50],
  ['UW', 'Bareilly', 3891.2, 5.89, 0.00, 1.72, 55],
  ['UW', 'Moradabad', 2936.4, 5.38, 0.05, 0.73, 82],
  ['HP', 'Kangra', 2541.4, 2.88, 1.30, 1.23, 55],
  ['HP', 'Mandi', 1790.4, 2.08, 1.44, 0.84, 52],
  ['UW', 'Bijnor', 1946.9, 3.30, 0.24, 0.07, 82],
];

export const CIRCLE_COLORS = { HP: '#062B55', KS: '#6FA8F7', JA: '#94A3B8', UW: '#F59E0B' };

export const CIRCLE_HEALTH = [
  { circle: 'HP', subtext: 'Kangra·Mandi·Shimla', km: 6873, gross: 72.8, net: 55.8, retained: 76.7, manpower: 8.6, pm: 4.1, cm: 3.3, ftkm: 0, avgCm: '52 / 100', penPerKm: 2.5, color: '#062B55' },
  { circle: 'KS', subtext: 'Srinagar', km: 4437, gross: 70.8, net: 51.8, retained: 73.1, manpower: 15.0, pm: 3.5, cm: 1.9, ftkm: 1.8, avgCm: '52 / 100', penPerKm: 4.3, color: '#6FA8F7' },
  { circle: 'JA', subtext: 'Jammu', km: 3553, gross: 55.6, net: 35.6, retained: 64.0, manpower: 10.6, pm: 5.7, cm: 2.1, ftkm: 0, avgCm: '52 / 100', penPerKm: 5.6, color: '#94A3B8' },
  { circle: 'UW', subtext: '10 MPs', km: 26040, gross: 263.1, net: 193.8, retained: 73.6, manpower: 56.3, pm: 5.9, cm: 9.8, ftkm: 5.4, avgCm: '64 / 100', penPerKm: 2.7, color: '#F59E0B' },
];

export const CIRCLE_HEALTH_TOTAL = {
  km: 40903, gross: 462.3, net: 337.0, retained: 72.9, manpower: 90.5, pm: 19.2, cm: 17.1, ftkm: 7.2, avgCm: '58 / 100', penPerKm: 3.1,
};

export const WATERFALL_STEPS = [
  { label: 'Gross Payout', anchor: true, val: 462.32, color: '#062B55' },
  { label: 'CM Penalty', down: true, val: 17.14, color: '#EF4444' },
  { label: 'FTKM Reward', down: false, val: 7.19, color: '#10B981' },
  { label: 'Patrolling', down: true, val: 0.73, color: '#F59E0B' },
  { label: 'PM Penalty', down: true, val: 19.25, color: '#F59E0B' },
  { label: 'Manpower Gap', down: true, val: 90.46, color: '#EF4444' },
  { label: 'Mat+PQ+Flap', down: true, val: 4.97, color: '#94a3b8' },
  { label: 'Net Payable', anchor: true, val: 336.97, color: '#6FA8F7' },
];

export const CIRCLE_RETENTION = [
  { circle: 'HP', pct: 76.7, net: 55.8, gross: 72.8, color: '#062B55' },
  { circle: 'KS', pct: 73.1, net: 51.8, gross: 70.8, color: '#6FA8F7' },
  { circle: 'JA', pct: 64.0, net: 35.6, gross: 55.6, color: '#94A3B8' },
  { circle: 'UW', pct: 73.7, net: 193.8, gross: 263.1, color: '#F59E0B' },
];

export const EXECUTIVE_NAV_TILES = [
  {
    tabIndex: 1,
    title: 'Manpower Gap Analysis',
    tone: 'red',
    icon: '',
    penalty: '₹90.5L',
    arrow: 'Open MP-level analysis →',
    stats: ['14/14 MPs impacted', 'Srinagar worst: ₹15.0L', 'UW: ₹56.3L (62% of total)', 'Intercity + Intracity split'],
  },
  {
    tabIndex: 2,
    title: 'PM Penalty Analysis',
    tone: 'orange',
    icon: '',
    penalty: '₹19.2L',
    arrow: 'Open WO-level analysis →',
    stats: ['6 MPs in 2× repeat penalty', 'Jammu: ₹5.71L (29.7%)', 'Bareilly: only 100% compliant', '3,569 non-billable KMs'],
  },
  {
    tabIndex: 3,
    title: 'CM KPI Penalty Analysis',
    tone: 'blue',
    icon: '',
    penalty: '₹9.96L net',
    arrow: 'Open KPI-level analysis →',
    stats: ['Gross ₹17.1L → net ₹9.96L', '28/28 rows: Patroller = 0/5', 'Bijnor: only MP earning reward', 'Hapur: score 35 - zone worst'],
  },
];

export const EXECUTIVE_INSIGHTS = [
  {
    tone: 'red',
    title: 'Manpower Is a Structural Crisis, Not an Ops Issue',
    exposure: '₹90.5L deducted · Srinagar alone: ₹15.03L for 4,437 KM (single MP, single circle)',
    body: 'Manpower Gap is 4.7× larger than the next biggest penalty and cannot be recovered by field-level improvements alone. The gap is not spread evenly - Srinagar (₹15.03L) and Jammu (₹10.58L) together account for ₹25.6L, or 28% of the total manpower penalty, on just 8,000 KM of scope. UW with 10 MPs loses ₹56.3L - an average of ₹5.6L per MP - primarily because of uncommitted intercity roving labour headcount. Until the commitment-vs-deployment gap is closed circle by circle, all other improvements are cosmetic.',
    actionTitle: 'Decision Required - HR / Ops Head',
    action: 'Circle-wise headcount gap audit: committed vs. deployed actuals this month. Any circle with >15% gap triggers immediate escalation. This is a resourcing governance failure, not a field performance failure.',
  },
  {
    tone: 'orange',
    title: 'PM Penalty Has a ₹6L Loop That Doubles Monthly If Ignored',
    exposure: '6 MPs in 2× repeat penalty · Jammu: ₹5.71L on 29.7% of zone PM pool · Bareilly: 0 penalty blueprint',
    body: 'PM deductions are generated when Work Orders are not closed within the billing month - a process discipline failure. Six MPs have triggered the 2× repeat clause, meaning their penalty is already doubled and will double again if unresolved. Jammu\'s ₹5.71L is the worst; it represents a 78.4% PM compliance rate - meaning 1 in 5 PM spans is unbilled. Bareilly achieves 100% compliance, proving this is entirely fixable through process, not capacity.',
    actionTitle: 'Decision Required - PM Lead + Circle Heads',
    action: 'Pull all WOs open >20 days. Run a daily war-room for 2× MPs until cleared. Prioritise Jammu, Srinagar, Hapur. Breaking the 2× loop saves ₹3L per billing cycle; preventing recurrence saves it every subsequent month.',
  },
  {
    tone: 'green',
    title: 'Up to ₹7.5L Is Recoverable With Zero Capital Outlay',
    exposure: 'Patroller discipline ~₹1.0L · GIS near-threshold MPs ~₹1.5L · PM 2× loop ₹3.0L · Jammu fault density ₹2.0L',
    body: 'Four non-capital actions together recover up to ₹7.5L. Patroller App (1.8A): patrolling activity is genuinely happening, but the SLA cliff is steep and no MP currently clears the bar. GIS Update (1.6): 5 MPs already score 10/10, proving the process is achievable. The opportunity is concentrated in Etawah Intercity, Bareilly Intercity, and Moradabad Intercity. Bijnor is the zone benchmark for what best-in-class looks like.',
    actionTitle: 'Action Owners - Circle Ops + GIS Team + PM Lead',
    action: 'Patroller - sustained field discipline push across all MPs, starting with Kangra Intracity. GIS - targeted entry clearance for Etawah, Bareilly, and Moradabad Intercity rows. PM - daily war-room for 2× repeat MPs. Jammu - repeat-fault span identification and permanent rectification. No capex required for any of these.',
  },
];

export const EXECUTIVE_RECOVERY = {
  heading: 'Penalty Recovery Roadmap - Dec\'25 Billing Cycle',
  title: '₹7.5L Recoverable This Cycle · ₹90L/Year If Sustained · Zero Capital Required',
  body: 'At Dec\'25\'s run-rate the zone forfeits ₹15.0 Crore every year to penalties. Four non-capex actions below address the recoverable portion immediately - process discipline, documentation compliance, and targeted field fixes.',
  headlineStats: [
    { value: '₹15.0 Cr', label: 'Annual penalty run-rate (current)', tone: 'red' },
    { value: '₹90L', label: 'Annual recovery if fixes sustained', tone: 'green' },
    { value: '27.1%', label: 'Of gross payout lost to deductions', tone: 'amber' },
  ],
  stripStats: [
    { value: '₹3.0L', annual: '₹36L/year if sustained', label: 'PM 2× Repeat Loop', sublabel: 'Largest single opportunity', tone: 'orange' },
    { value: '₹2.0L', annual: '₹24L/year if sustained', label: 'Jammu Fault Density', sublabel: 'Field investigation fix', tone: 'orange' },
    { value: '₹1.5L', annual: '₹18L/year if sustained', label: 'GIS Near-Threshold MPs', sublabel: 'Back-office data entry only', tone: 'green' },
    { value: '₹1.0L', annual: '₹12L/year if sustained', label: 'Patroller 1.8A SLA', sublabel: 'Field discipline push', tone: 'green' },
  ],
  items: [
    {
      tone: 'orange',
      category: 'Highest Impact - Process Fix',
      title: 'PM 2× Repeat Penalty Loop - 6 MPs Already Triggered',
      value: '₹3.0L',
      annual: 'this cycle · ₹36L/year if loop is broken permanently',
      reason: 'The 2× clause fires when the same WO remains open across two consecutive billing months. Six MPs have triggered it - Jammu, Srinagar, Kangra, Hapur, Aligarh, Meerut - and the penalty doubles again next cycle if unresolved. Bareilly achieves 100% WO closure with zero PM penalty under the same SLA, confirming this is a tracking ownership failure, not a capacity issue.',
    },
    {
      tone: 'orange',
      category: 'Field Investigation',
      title: 'Jammu Intercity Fault Density - 4× Worse Than Zone Avg',
      value: '₹2.0L',
      annual: 'this cycle · ₹24L/year if fault rate normalised',
      reason: 'Jammu Intercity recorded 65 faults in Dec\'25 - FTKM of 26.2 vs. a zone average of 6.5, 4× worse than peers. Root cause is likely a small set of spans being temporarily patched rather than permanently rectified. Fixing the top 10-15 repeat-fault spans improves FTKM score, TTR compliance, and FTKM reward eligibility simultaneously.',
    },
    {
      tone: 'green',
      category: 'Low Hanging Fruit - No Fieldwork Required',
      title: 'GIS Update 1.6 - Three MPs Just Below the Scoring Gate',
      value: '~₹1.5L',
      annual: 'this cycle · ₹18L/year - pure documentation sprint',
      reason: '5 MPs already score 10/10 at 100% GIS compliance - proving the process is fully achievable. Scoring gate: >90% = 5 pts, >95% = 10 pts. Three MPs sit just below the 5-pt threshold and need only targeted backlog clearance: Etawah Intercity (83.3%), Bareilly Intercity (80.0%), Moradabad Intercity (75.0%).',
    },
    {
      tone: 'green',
      category: 'Operational Discipline',
      title: 'Patroller App 1.8A - All 14 MPs Below the Scoring Threshold',
      value: '~₹1.0L',
      annual: 'this cycle · ₹12L/year - operational, not a tech issue',
      reason: 'Patrolling activity is happening - compliance values range 0-88.9% - but the SLA cliff is steep: <95% = 0 pts, 95-98% = 3 pts, >98% = 5 pts. No MP clears the bar today. This is a route coverage and field discipline gap, not an IT failure.',
    },
  ],
};

export const EXECUTIVE_ACTIONS = [
  { priority: 'P1', action: 'Headcount gap audit - all 14 MPs.', category: 'Manpower', saving: '₹90.5L at risk', owner: 'HR / Ops Head' },
  { priority: 'P1', action: 'PM 2× war-room - Jammu, Srinagar, Hapur, Meerut, Aligarh, Kangra.', category: 'PM Penalty', saving: '~₹3.0L', owner: 'PM Lead · Circle Heads' },
  { priority: 'P2', action: 'Patroller App 1.8A - field discipline push.', category: 'CM KPI', saving: '~₹1.0L', owner: 'Circle Ops · Field Supervisors' },
  { priority: 'P2', action: 'GIS Update 1.6 - targeted clearance for near-threshold MPs.', category: 'CM KPI', saving: '~₹1.5L', owner: 'GIS Team · Circle Ops' },
  { priority: 'P2', action: 'Jammu Intercity fault density reduction.', category: 'CM / Faults', saving: '~₹2.0L', owner: 'JA Circle Head · Tech Lead' },
  { priority: 'P3', action: 'Bijnor Circle-of-Excellence knowledge transfer.', category: 'CM Capability', saving: '₹5-8L upside', owner: 'Ops Head · UW Head' },
];
